import { ajaxErrorAlert, ajaxPost } from "./utils";
import { getJsContext, getRecaptchaToken } from "../app";

$(function () {
  const body = $("body");

  if (body.hasClass("pay")) {
    $("input[name=cardholder_screen_width]").val(window.innerWidth);
    $("input[name=cardholder_screen_height]").val(window.innerHeight);

    $(document).on("submit", "#azericardCardholderDataForm", (e) => {
      e.preventDefault();
      const form = $(e.target);

      getRecaptchaToken(form, {
        position: "center",
        extraClasses: "wy110",
      }).then(() => {
        const data = form.serializeArray();
        form.loading({
          loadingText: getJsContext("please_wait") + "...",
          extraClasses: "wy110",
        });

        ajaxPost("", data, form)
          .then((response) => {
            form.loading({
              loadingText: getJsContext("redirecting") + "...",
              extraClasses: "wy110",
            });
            window.location.href = String(response["redirect_url"]);
          })
          .catch((errors) => {
            ajaxErrorAlert(errors, form);
          });
      });
    });

    $(document).on("submit", "#payriffPaymentForm", (e) => {
      e.preventDefault();
      const form = $(e.target);

      getRecaptchaToken(form, {
        position: "center",
        extraClasses: "wy110 bg-white",
      }).then(() => {
        const data = form.serializeArray();
        form.loading({
          loadingText: getJsContext("please_wait") + "...",
          extraClasses: "wy110 bg-white",
        });

        ajaxPost("", data, form)
          .then((response) => {
            form.loading({
              loadingText: getJsContext("redirecting") + "...",
              extraClasses: "wy110 bg-white",
            });
            window.location.href = String(response["redirect_url"]);
          })
          .catch((errors) => {
            ajaxErrorAlert(errors, form);
          });
      });
    });
    $("#payriffPaymentForm").trigger("submit");
  }

  if (body.hasClass("check")) {
    const form = $("#checkPaymentForm");
    const data = form.serializeArray();

    const showPaymentDetailDiv = () => {
      $(".paymentLoadingDiv").addClass("d-none");
      $(".paymentDetailDiv").show();
    };

    async function checkPayment(checkCount = 0) {
      const maxCheckCount = 30;
      const delay = 2000;
      console.info(
        "Checking payment status...",
        `${maxCheckCount}/${checkCount}`,
      );

      if (checkCount > maxCheckCount) {
        showPaymentDetailDiv();
        $(".paymentDetailDiv a").trigger("click");
        return;
      }

      if (checkCount >= 5) {
        // Try self - this means that we will check payment status from our side.
        // Don't wait callback from payment gateway
        data.push({ name: "try_self", value: "1" });
      }

      await ajaxPost("", data, form)
        .then((response) => {
          if (response["payment_status"] !== "PENDING") {
            form.loading({
              loadingText: getJsContext("redirecting") + "...",
            });
            window.location.href = String(response["redirect_url"]);
          } else {
            setTimeout(() => {
              checkCount += 1;
              checkPayment(checkCount);
            }, delay);
          }
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
          showPaymentDetailDiv();
        });
    }
    checkPayment();
  }
});
